import { Injectable } from '@angular/core';
import { LotsLogicService } from '@app/logic/lots';
import {
    MigrateLotsWizardDocumentsLogicService
} from '@app/logic/migrate-lots-wizard-documents';
import {
    MigrateLotsWizardHistoryLogicService
} from '@app/logic/migrate-lots-wizard-history';
import { ReleaseStagesLogicService } from '@app/logic/release-stages/release-stages.logic.service';
import { UtilFiles } from '@app/shared/utils/file.util';
import { map, Observable, of, take } from 'rxjs';
import {
    IMigrateLotsWizardDocumentAssignmentDto,
    IMigrateLotsWizardDocumentMigrateResponseDto,
    IMigrateLotsWizardHistoryRequestDto,
    IProjectReleaseLotMigrationSourceSelectionGroupDto
} from '@classictechsolutions/hubapi-transpiled-enums';


@Injectable({ providedIn: 'root' })
export class LotMigratorExecutionService {
    constructor(
        private readonly lotsLogicService: LotsLogicService,
        private readonly releaseStagesLogicService: ReleaseStagesLogicService,
        private readonly migrateLotsWizardDocumentsLogicService: MigrateLotsWizardDocumentsLogicService,
        private readonly migrateLotsWizardHistoryLogicService: MigrateLotsWizardHistoryLogicService
    ) {}

    public cancelLot(lotId: number): Observable<number[]> {
        return this.lotsLogicService.deleteLot(lotId).pipe(take(1));
    }

    public uploadFile(projectReleaseId: number, file: File): Observable<any> {
        if (!file.name.match(UtilFiles.isExcelFile)) {
            return of(false);
        }

        return this.releaseStagesLogicService.importLots(projectReleaseId, file, false).pipe(take(1));
    }

    public getDestinationLotIdMap(projectReleaseId: number): Observable<Map<number, number>> {
        return this.releaseStagesLogicService.getProjectReleaseStageLots(projectReleaseId).pipe(
            take(1),
            map(lots => {
                const lotIdByNumber = new Map<number, number>();

                lots.forEach(lot => {
                    if (lot.lotNumber != null) {
                        lotIdByNumber.set(lot.lotNumber, lot.id);
                    }
                });

                return lotIdByNumber;
            })
        );
    }

    public getFilteredMigrationLots(
        projectReleaseId: number,
        selectedLotIds: number[]
    ): Observable<IProjectReleaseLotMigrationSourceSelectionGroupDto[]> {
        return this.releaseStagesLogicService
            .getProjectReleaseStageMigrationLots(projectReleaseId, selectedLotIds)
            .pipe(take(1));
    }

    public migrateDocuments(
        assignments: IMigrateLotsWizardDocumentAssignmentDto[]
    ): Observable<IMigrateLotsWizardDocumentMigrateResponseDto> {
        return this.migrateLotsWizardDocumentsLogicService
            .migrateDocuments(assignments)
            .pipe(take(1));
    }

    public migrateHistory(request: IMigrateLotsWizardHistoryRequestDto): Observable<boolean> {
        return this.migrateLotsWizardHistoryLogicService
            .addHistoryEntries(request)
            .pipe(take(1));
    }
}
